export default {
  title: '',
  tab: 'CANDIDATES'
}
